import React from "react";

export default function AlwaseetInvoiceDetails() {
  return <div>تفاصيل فاتورة الوسيط</div>;
}